import AccountCircle from '@mui/icons-material/AccountCircle';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import FavoriteIcon from '@mui/icons-material/Favorite';
import SavedSearchIcon from '@mui/icons-material/SavedSearch';
import { Grid } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { appRoutes } from 'app/app-routes';
import logo from 'images/logo.png';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { cacheActions, cacheSelectors } from 'redux/cache.slice';
import { RootState } from 'redux/root-reducer';
import { searchParamSelectors } from 'redux/search-param.slice';

const Nav = () => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);
  const user = useSelector((state: RootState) => cacheSelectors.user(state));
  const urlParams = useSelector((state: RootState) => searchParamSelectors.urlParams(state));

  const handleUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    if (user) {
      dispatch(cacheActions.user(undefined));
      dispatch(
        cacheActions.addSnack({
          message: 'User logged out',
          variant: 'success',
        }),
      );
    }
    handleUserMenuClose();
  };

  interface NavItem {
    label: string;
    route: string;
  }

  const links: NavItem[] = [
    { label: 'Search', route: `${appRoutes.search}?${urlParams}` },
    { label: 'Sell Your Car', route: appRoutes.sell },
    { label: 'Research', route: appRoutes.home },
    { label: 'Categories', route: appRoutes.home },
  ];

  return (
    <AppBar position="static">
      <Grid container component={Toolbar} justifyContent="center">
        <Grid container maxWidth="lg" gap={4}>
          <NavLink to={appRoutes.home}>
            <img style={{ height: 34 }} src={logo} alt="Logo" />
          </NavLink>
          {links.map(x => (
            <Box key={x.label}>
              <NavLink to={x.route} key={x.label}>
                <Typography mr={0} mt={'5px'} color={'white'} variant="h6">
                  {x.label}
                </Typography>
              </NavLink>
            </Box>
          ))}
          <Box flexGrow={1} />
          {user ? (
            <>
              <IconButton
                aria-label="account of current user"
                aria-controls="user-appbar"
                aria-haspopup="true"
                onClick={handleUserMenu}
                color="secondary"
                size="large"
                sx={{ marginTop: '5px', padding: 0 }}
              >
                <AccountCircle color="secondary" fontSize="large" />
                <Typography color="secondary" pl={1} variant="h6">
                  {user.firstName}
                </Typography>
                <ArrowDropDownIcon color="secondary" fontSize="large" />
              </IconButton>
              <Menu
                id="user-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={menuOpen}
                onClose={handleUserMenuClose}
              >
                <NavLink to={appRoutes.profile}>
                  <MenuItem onClick={handleUserMenuClose}>
                    <ListItemIcon>
                      <AccountCircle fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Profile</ListItemText>
                  </MenuItem>
                </NavLink>
                <NavLink to={appRoutes.favorites}>
                  <MenuItem onClick={handleUserMenuClose}>
                    <ListItemIcon>
                      <FavoriteIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Favorites</ListItemText>
                  </MenuItem>
                </NavLink>
                <NavLink to={appRoutes.savedSearches}>
                  <MenuItem onClick={handleUserMenuClose}>
                    <ListItemIcon>
                      <SavedSearchIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Saved Searches</ListItemText>
                  </MenuItem>
                </NavLink>
                <NavLink to={appRoutes.sell}>
                  <MenuItem onClick={handleUserMenuClose}>
                    <ListItemIcon>
                      <DirectionsCarIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>My Listings</ListItemText>
                  </MenuItem>
                </NavLink>
                <Divider variant="middle" />
                <MenuItem onClick={handleLogout}>Logout</MenuItem>
              </Menu>
            </>
          ) : (
            <>
              <NavLink to={appRoutes.register}>
                <Typography color={'white'} mt={'5px'} variant="h6">
                  Create Account
                </Typography>
              </NavLink>
              <NavLink to={appRoutes.login}>
                <Typography color={'white'} mt={'5px'} variant="h6">
                  Log In
                </Typography>
              </NavLink>
            </>
          )}
        </Grid>
      </Grid>
    </AppBar>
  );
};

export default Nav;
